<template>
  <section
    class="app-ranking border container"
    :class="{ loaded: loadedView.indexOf('ranking') !== -1 }"
  >
    <h3 class="block__topic" id="ranking">大赛排行</h3>

    <button
      class="app-ranking__btn app-ranking__btn-bold"
      :class="{ active: group === 2 }"
      @click="() => onGroupChange(2)"
    >
      <span>重量组TOP10</span>
    </button>
    <button
      class="app-ranking__btn app-ranking__btn-light"
      :class="{ active: group === 1 }"
      @click="() => onGroupChange(1)"
    >
      <span>轻量组TOP10</span>
    </button>

    <div class="app-ranking-bar">
      <button
        class="app-ranking-bar__btn"
        @click="() => onWeekOrTotalChange('total')"
        :class="{ active: weekOrTotal === 'total' }"
      >
        <span>总排行榜</span>
      </button>

      <div
        class="app-ranking-bar__btn"
        @click="onTriggerDropdown"
        :class="{ active: weekOrTotal === 'week' }"
      >
        <span style="margin-left: -4px">
          {{ currentWeek }}
          <i class="arrow" :class="{ opened: dropdownVisible }"></i>
        </span>

        <div class="dropdown" v-if="dropdownVisible">
          <iscroll-view>
            <ul>
              <li
                v-for="item in weeks"
                :key="item.value"
                @click.self="e => onWeekChange(item.value, e)"
                :class="{ active: week === item.value }"
              >{{ item.label }}</li>
            </ul>
          </iscroll-view>
        </div>
      </div>

      <!-- <button
        class="app-ranking-bar__btn extra"
        @click="() => onWeekOrTotalChange('total')"
        :class="{ active: weekOrTotal === 'total' }"
        style="margin-right: 8px"
      >
        <span>浮动盈亏排行榜</span>
      </button> -->

      <span class="app-ranking-bar__time">更新时间：{{ updateTime }}</span>
    </div>

    <div class="app-ranking-table">
      <Table
        :user="user"
        :group="group"
        :week="week"
        :weeksOptions="weeks"
        :isLastWeek="isLastWeek"
        :weekOrTotal="weekOrTotal"
        @updateTimeChange="onUpdateTimeChange"
      />
    </div>
  </section>
</template>

<script>
import { getNow } from '@/api'
import dayjs from 'dayjs'
import Table from "./Table";

export default {
  name: "Ranking",
  props: {
    user: [Object, null],
    loadedView: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    Table
  },
  data() {
    return {
      group: 1,
      weekOrTotal: "total",
      updateTime: "",
      week: "",
      dropdownVisible: false,
      weeks: [
        { value: "2020-08-17~2020-08-23", label: "第一周" },
        { value: "2020-08-24~2020-08-30", label: "第二周" },
        { value: "2020-08-31~2020-09-06", label: "第三周" },
        { value: "2020-09-07~2020-09-13", label: "第四周" },
        { value: "2020-09-14~2020-09-20", label: "第五周" },
        { value: "2020-09-21~2020-09-27", label: "第六周" },
        { value: "2020-09-28~2020-10-11", label: "第七周" },
        { value: "2020-10-12~2020-10-18", label: "第八周" },
        { value: "2020-10-19~2020-10-25", label: "第九周" },
        { value: "2020-10-26~2020-11-01", label: "第十周" },
      ]
    };
  },
  computed: {
    currentWeek() {
      if (this.weekOrTotal === 'total') {
        return '周排行榜' 
      }

      return (this.weeks.find(item => item.value === this.week) || {}).label
    },
    isLastWeek() {
      if (!this.week || this.weekOrTotal === 'total') {
        return false
      }

      const today = new Date()
      const selected = new Date(this.week.split('~')[1])

      return today > selected ? true : false
    }
  },
  created() {
    if (this.weekOrTotal === 'total') {
      return false
    }

    // 周一 20 点前获取上一周数据， 8点后获取当周数据
    // 国庆期间两周并为一周 第七周的时间 2020-09-28 到 2020-10-11
    getNow().then(res => {
      const currentDay = dayjs(res.data)
      const date = currentDay.format('YYYY-MM-DD')
      const dayOfWeek = currentDay.day()
      const hourOfDay = currentDay.hour()
      let displayLastWeek = false

      if (dayOfWeek === 1 && hourOfDay < 20 && date !== '2020-10-05') {
        displayLastWeek = true
      }

      const now = +new Date()

      for (let i = 0; i < this.weeks.length; i++) {
        const item = this.weeks[i]
        const arr = item.value.split('~')
        const start = new Date(arr[0].replace(/-/g, '/') + ' 00:00:00')
        const end = new Date(arr[1].replace(/-/g, '/') + ' 23:59:59')

        if (now >= start && now <= end) {
          this.week = item.value

          if (displayLastWeek) {
            this.week = this.weeks[i - 1].value
          }
          break
        }
      }
    })
  },
  methods: {
    onTriggerDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    onGroupChange(group) {
      this.group = group;
      this.dropdownVisible = false
    },
    onWeekOrTotalChange(weekOrTotal) {
      this.weekOrTotal = weekOrTotal;
      if (weekOrTotal === 'total') {
        this.week = ''
      }
    },
    onUpdateTimeChange(time) {
      this.updateTime = time;
    },
    onWeekChange(week) {
      this.onWeekOrTotalChange("week");
      this.week = week;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";

.app-ranking {
  position: relative;
  margin-top: percentage(114px / $baseWidth);
  border: 2px solid;
  border-image: linear-gradient(
      360deg,
      rgba(134, 76, 46, 0.26),
      rgba(134, 76, 46, 0.52),
      rgba(134, 76, 46, 0.46),
      rgba(134, 76, 46, 1),
      rgba(134, 76, 46, 0.2)
    )
    2 2;
  border-top: none;
  border-top: 0;

  &.loaded {
    animation: fadeInUp .3s .3s both;
  }

  &-table {
    padding: 0 percentage(20px / 1200px);
  }

  &__btn,
  &-bar__btn {
    cursor: pointer;
    position: relative;
    span {
      position: absolute;
      @include middle();
      font-size: 14px;
      white-space: nowrap;
      color: $primaryColor;
    }
  }

  &-bar {
    padding: percentage(40px / 1200px) percentage(20px / 1200px)
      percentage(18px / 1200px);
    
    &__btn {
      position: relative;
      display: inline-block;
      width: percentage(98.5px / 1140px);
      min-width: 86px;
      min-height: 24px;
      margin-right: 8px;
      padding-top: percentage(27px / 1140px);
      overflow: visible;
      vertical-align: middle;
      background: url(../../assets/btn-2-normal.png) center/contain no-repeat;
      span {
        font-size: 12px;
      }

      &.extra {
        min-width: 106px;
        width: percentage(114px / 1140px);
        background-size: 100% 100%;
      }

      .arrow {
        display: block;
        position: absolute;
        top: 50%;
        right: -12px;
        margin-top: -3px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 5px 5px 0 5px;
        border-color: #985e57 transparent transparent transparent;

        &.opened {
          margin-top: -4px;
          border-width: 0 5px 5px 5px;
          border-color: transparent transparent #985e57 transparent;
        }
      }

      &.active {
        span {
          color: #ebc4bc;
        }

        .arrow {
          border-color: #ebc4bc transparent transparent transparent;

          &.opened {
            border-color: transparent transparent #ebc4bc transparent;
          }
        }
      }
    }
    &__time {
      float: right;
      color: $primaryColor;
      font-size: 13px;
      line-height: 24px;
    }

    .dropdown {
      position: absolute;
      z-index: 99;
      top: 100%;
      left: 0;
      width: 100%;
      height: 140px;
      padding: 12px 0 16px;
      background: url(../../assets/dropdown.png) center/contain no-repeat;
      ul {
        height: 100%;
        overflow: auto;
      }

      li {
        font-size: 14px;
        line-height: 24px;
        color: $primaryColor;
        text-align: center;

        &.active {
          color: #ebc4bc;
          background: url(../../assets/dropdown-btn.png) center bottom/contain
            no-repeat;
        }
      }
    }
  }

  &__btn {
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    width: percentage(189px / 1200px);
    padding-top: percentage(39px / 1200px);
    color: $primaryColor;
    cursor: pointer;
    @include image-2x(
      "../../assets/btn-1-normal@1x.png",
      center top,
      no-repeat,
      100% auto
    );

    span {
      font-size: 16px;
    }

    &.app-ranking__btn-bold {
      left: percentage(276px / 1200px);
    }

    &.app-ranking__btn-light {
      right: percentage(276px / 1200px);
    }

    &.active {
      @include image-2x(
        "../../assets/btn-1-active@1x.png",
        center top,
        no-repeat,
        100% auto
      );
    }
  }

  .block__topic {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -65.0625%);
    @include image-2x(
      "../../assets/title-rank@1x.png",
      center top,
      no-repeat,
      100% auto
    );
  }
}

@include mobile {
  .app-ranking {
    &-table {
      padding: 0 percentage(8px / 406px);
    }

    &__btn,
    &-bar__btn {
      span {
        font-size: 11px;
      }
    }

    &-bar {
      padding: percentage(18px / 406px) percentage(8px / 406px)
        percentage(14px / 406px);
      &__btn {
        position: relative;
        width: percentage(76px / 390px);
        min-width: 76px;
        min-height: 21px;
        padding-top: percentage(27px / 390px);
        background: url(../../assets/btn-2-normal.png) center/contain no-repeat;
        span {
          font-size: 11px;
        }

        .arrow {
          margin-top: -1px;
          border-width: 4px 4px 0 4px;

          &.opened {
            margin-top: -2px;
            border-width: 0 4px 4px 4px;
          }
        }
      }
      &__time {
        float: right;
        color: $primaryColor;
        font-size: 11px;
        line-height: 24px;
      }

      .dropdown {
        position: absolute;
        z-index: 99;
        top: 100%;
        left: 0;
        width: 100%;
        height: 140px;
        padding: 12px 0 16px;
        background: url(../../assets/dropdown.png) center/contain no-repeat;
        ul {
          height: 100%;
          overflow: auto;
        }

        li {
          font-size: 14px;
          line-height: 24px;
          color: $primaryColor;

          &.active {
            color: #ebc4bc;
            background: url(../../assets/dropdown-btn.png) center bottom/contain
              no-repeat;
          }
        }
      }
    }
  }
}

@include pad {
  .app {
    &-ranking {
      &-bar__btn {
        span {
          font-size: 15px;
        }
      }

      &-bar__time {
        font-size: 15px;
        line-height: 36px;
      }
    }
  }
}
</style>
